module.exports = __webpack_public_path__ + "img/belt.fa58bb02.jpg";